<script setup lang="ts">
import Button from 'primevue/button'
import StoreSaleForm from './StoreSaleForm.vue'
import { useVolverAlListado } from '@/composables/useVolverAlListado'

/**
 * Alta de una venta de tienda.
 *
 * No crea un borrador al entrar: la venta se escribe en un solo acto. Si se
 * cierra el formulario sin guardar, no queda una fila vacía en el listado.
 */

const { volver: volverAlListado } = useVolverAlListado('store-sales.index')
</script>

<template>
  <div class="space-y-6 animate-fade-in">
    <header class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 class="text-2xl font-semibold text-surface-900 dark:text-surface-100">
          Nueva venta de tienda
        </h1>
        <p class="mt-1 text-sm text-surface-500 dark:text-surface-400">
          Cabecera del cliente, valor de la venta y facturación
        </p>
      </div>

      <Button
        label="Volver"
        icon="pi pi-arrow-left"
        severity="secondary"
        outlined
        @click="volverAlListado()"
      />
    </header>

    <StoreSaleForm :sale="null" />
  </div>
</template>
